import { arrayMove } from '@/utils/array';
import { groupBy, maxBy, orderBy, sum, sumBy } from 'es-toolkit';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import {
  SHIPMENT_TRANSPORTATION_ADDITIONAL_INFO_POST,
  SHIPMENT_TRANSPORTATION_OBJECTS,
  SHIPMENT_TRANSPORTATION_TYPES,
  SHIPMENT_TRANSPORTATION_TYPES_ID,
} from '../contants/Fields';
import { SHIPMENT_RATE_SHOP_RATTING_PREFERENCES } from '../contants/ShipmentEnums';
import { SP_CARRIERS_TYPES } from '../contants/common';
import {
  combineDateTimeMoment,
  convertDateESTToUTCToUserLocal,
  convertDateStringtoMoment,
  convertDateToMoment,
  convertDateUserLocalToUTCToEST,
  convertLocalToEST,
  convertTimetoMoment,
  convertUserLocalToEST,
  dateTimeToSingleValue,
  formateWithMoment,
  getFormattedTimeString,
  mergeDateAndTimeObjectsWithTimeZone,
  truncateTimeZoneDate,
} from './dates';
import { nullToValue, stringToNull, trimObjectValues, valueToNull, valueToNumber, valueToString } from './format';
import { calCulateFreightClass, getRateShopStringAll, validateProductForCalculateClass } from './utilz';

export const convertShipmentApiResponseToLocal = (shipment) => {
  return {
    ...shipment,
    transportationList: convertTransporationToLocal(shipment),
    additionalDetails: convertAdditionalDetailsToLocal(shipment),
    rateShopList: shipment.rateShopDetails?.map((row) => ({
      ...row,
      accessorials: row.freightAccessorialCollection
        ? row.freightAccessorialCollection?.map((row) => ({
            ...row,
            description: row.costName,
            auditedChargeAmount: row.cost,
            currencyCode: row.currency,
          }))
        : [],
      createdOn: convertDateESTToUTCToUserLocal(row.createdOn),
      effectiveTo: convertDateESTToUTCToUserLocal(row.effectiveTo),
    })),
    shipmentVendorList: shipment.shipmentVendorDetails,
    shipmentBillingDetails: shipment.shipmentBillToInfo,
    shipmentFilesList: shipment.shipmentDocuments.map((row) => ({
      renderKey: uuidv4(),
      ...row,
    })),
    shipmentCategoryList: shipment.hierarchialDetails,
    taxes: shipment.shipmentTaxes,
  };
};
export const convertTransporationToLocal = (shipment) => {
  const localData = [];
  for (const key in SHIPMENT_TRANSPORTATION_OBJECTS) {
    const value = SHIPMENT_TRANSPORTATION_OBJECTS[key];
    if (Object.hasOwnProperty.call(shipment, value)) {
      const rows = shipment[value];
      rows?.forEach((row) => {
        let data = {};
        data.transportationType = SHIPMENT_TRANSPORTATION_TYPES[SHIPMENT_TRANSPORTATION_OBJECTS[key]];

        const TYPE_NO = SHIPMENT_TRANSPORTATION_TYPES[SHIPMENT_TRANSPORTATION_OBJECTS[key]];
        const TYPE =
          TYPE_NO === SHIPMENT_TRANSPORTATION_TYPES[SHIPMENT_TRANSPORTATION_OBJECTS.PICKUP]
            ? { short: 'shipper', additional: 'originAdditionalInfo' }
            : { short: 'consignee', additional: 'destinationAdditionalInfo' };

        data.stopType = valueToString(SHIPMENT_TRANSPORTATION_TYPES[SHIPMENT_TRANSPORTATION_OBJECTS[key]]);
        data.appointmentNo = row[`${TYPE.short}ReferenceNo`];
        data.primaryKey = row[`${TYPE.short}Key`];
        data.appointmentType = row[`${TYPE.short}AppointmentType`];
        data.requestedDate = convertToMoment(
          row[TYPE.additional][`${TYPE_NO === 1 ? 'shipperRequestedShipDate' : 'shipperRequestedDeliveryDate'}`],
        );

        data.requestedTime = convertToMoment(
          row[TYPE.additional][`${TYPE_NO === 1 ? 'shipperRequestedShipDate' : 'shipperRequestedDeliveryDate'}`],
        );

        data.appointmentDate = convertToMoment(
          row[TYPE.additional][`${TYPE_NO === 1 ? 'carrierAppontmentShipDate' : 'carrierAppontmentDeliveryDate'}`],
        );

        data.appointmentTime = convertToMoment(
          row[TYPE.additional][`${TYPE_NO === 1 ? 'carrierAppontmentShipDate' : 'carrierAppontmentDeliveryDate'}`],
        );

        data.actualDate = convertToMoment(
          row[TYPE.additional][`${TYPE_NO === 1 ? 'carrierActualShipDate' : 'carrierActualDeliveryDate'}`],
        );

        data.actualTime = convertToMoment(
          row[TYPE.additional][`${TYPE_NO === 1 ? 'carrierActualShipDate' : 'carrierActualDeliveryDate'}`],
        );

        data = {
          ...data,
          ...row[TYPE.additional],
          ...getDecodeWeeklyDaysOperation(row.weeklyOperation),
          ...getDecodeWeeklyHoursOperation(row.hoursOperation),
        };
        data.shipmentKey = row.shipmentKey;
        data.id = row.id;
        data.legNumber = row.legNumber;
        data.sequence = valueToString(row.sequence);
        data.searchId = row.searchId;
        data.name = row.name;
        data.address1 = row.address1;
        data.address2 = row.address2;
        data.zipCode = row.zipCode;
        data.city = row.city;
        data.stateCode = row.stateCode;
        data.countryCode = row.countryCode;
        data.businessPhone = row.businessPhone;
        data.matchedBolKey = row.matchedBolKey;
        data.portName = row.portName;
        data.portType = row.portType;
        data.portCode = row.portCode;
        data.portRecKey = row.portRecKey;
        data.countryName = row.countryName;
        data.stateName = row.stateName;
        data.hrsOfOperation = row.hrsOfOperation;
        data.weeklyOperation = row.weeklyOperation;
        data.hoursOperation = row.hoursOperation;
        data.legMiles = row.legMiles;
        data.customerKey = row.customerKey;
        data.oldStopSequence = row.oldStopSequence;
        data.createdBy = row.createdBy;
        data.extension = row.extension;
        data.dockNumber = row.dockNumber;
        data.displaySequence = valueToString(row.displaySequence);
        data.gridOperation = 2;
        data.isResetNew = 0;
        data.latitude = row.latitude;
        data.longitude = row.longitude;
        data.totalWeight = row.totalWeight;
        for (const key in data) {
          if (typeof data[key] === 'string') {
            data[key] = data[key].trim();
          }
        }

        localData.push(data);
        data.shipperAppointmentType = row.shipperAppointmentType;
        data.consigneeAppointmentType = row.consigneeAppointmentType;
        data.trailerNumber = row.trailerNumber;
        data.isModifiedDateTime = row[TYPE.additional].isModifiedDateTime;
      });
    }
  }
  return orderBy(localData, ['displaySequence'], ['asc']);
};

export const getDecodeWeeklyDaysOperation = (_date = '') => {
  const date = _date || '';
  let [fromOperationDay, toOperationDay] = String(date || '')
    .split('TO')
    .map((ele) => (ele.trim()?.length > 0 ? ele.trim() : undefined));
  fromOperationDay = String(fromOperationDay) === 'undefined' ? undefined : fromOperationDay;
  toOperationDay = String(toOperationDay) === 'undefined' ? undefined : toOperationDay;
  return { fromOperationDay, toOperationDay };
};

export const getDecodeWeeklyHoursOperation = (_date = '') => {
  const date = _date || '';
  const [fromOperationHours, toOperationHours] = String(date || '')
    .split('TO')
    .map((ele) => (ele.trim()?.length > 0 ? ele.trim() : undefined));
  return {
    fromOperationHours: fromOperationHours ? convertTimetoMoment(fromOperationHours) : '',
    toOperationHours: toOperationHours ? convertTimetoMoment(toOperationHours) : '',
  };
};

export const convertAdditionalDetailsToLocal = (shipment) => {
  return {
    status: shipment.status,
    shipmentCost: shipment.shipmentCost,
    currencyCode: shipment.currencyCode,
    shipmentType: shipment.shipmentType,
    shipmentTerms: shipment.shipmentTerms,
    proNo: shipment.proNo,
    masterBolNumber: shipment.masterBolNumber,
    accountNumber: shipment.accountNumber,
    hazmatContactName: shipment.hazmatContactName,
    freightAllowance: shipment.freightAllowance,
    createdByName: shipment.createdByName,
    createdOn: convertDateStringtoMoment(shipment.createdOn),
    modifiedByName: shipment.modifiedByName,
    modifiedOn: convertDateStringtoMoment(shipment.modifiedOn),
    branchKey: shipment.branchKey,
    incoCode: shipment.incoCode,
    incoPoint: shipment.incoPoint,
    fobCode: shipment.fobCode,
    createdBy: valueToNull(shipment.createdBy),
    modifiedBy: valueToNull(shipment.modifiedBy ? valueToNumber(shipment.modifiedBy) : shipment.modifiedBy),
    bolNumber: shipment.bolNumber,
    carrierKey: valueToNull(shipment.carrierKey),
    carrierName: shipment.carrierName,
    trailerNumber: shipment.trailerNumber,
    poNumber: shipment.poNumber,
    purchaseOrderNumber: shipment.purchaseOrderNumber,
    salesOrderNumber: shipment.salesOrderNumber,
    paymentTerms: shipment.paymentTerms,
    paidAmount: shipment.paidAmount,
    isMasterShipment: shipment?.isMasterShipment === 'Y',
    isChildShipment: shipment?.isChildShipment === 'Y',
    shipmentTermsDesc: shipment.shipmentTermsDesc,
    shipmentTypeDesc: shipment.shipmentTypeDesc,
    branchDesc: shipment.branchDesc,
    cargoType: shipment.cargoType,
    cargoTypeDesc: shipment.cargoTypeDesc,
    incoTerms: shipment.incoTerms,
    shipmentOriginator: shipment.shipmentOriginator,
    pickupConfirmationNumber: shipment.pickupConfirmationNumber,
  };
};

const convertToMoment = (date) => {
  if (!date) {
    return undefined;
  }
  return convertDateESTToUTCToUserLocal(date);
};

export const getShipmentTypeCounts = (type, listData) =>
  listData?.filter((data) => data.transportationType === type).length;

// ----------------Converting local data to API-----------------
export const convertShipmentDetailsLocalToAPI = ({ action, customerKey, masterShipment, ...data }) => {
  const userInfo = localStorage.getItem('userInfo');
  const userId = (userInfo ? JSON.parse(userInfo) : {}).id;
  let newData = {
    action,
    userId,
  };

  newData.shipmentInformationRequest = convertAdditionalDetailsLocalToAPI(
    data.additionalDetails,
    data,
    customerKey,
    data.shipmentKey,
    data.shipmentNo,
    userId,
    data.approvalNumber,
    masterShipment,
  );

  newData = {
    ...newData,
    ...convertTransportationListLocalToAPI(data.transportationList, userId),
    ...fixedData,
  };

  newData.shipmentProductInformation = convertProductLocalToAPI(data.productList, data.shipmentKey, userId);
  newData.shipmentBillToRequestInformation = convertBillLocaltoAPI(data.shipmentBillToInfo, data.shipmentKey, userId);
  newData.shipmentVendorRequestInformation = convertVendorLocalToAPI(data.shipmentVendorList, data.shipmentKey, userId);
  newData.shipmentDocumentInformation = convertDocumentsLocalToApiForAddShipment(data.documentList);
  newData.shipmentCategoryInformation = convertCategoryLocalToAPI(
    data.shipmentCategoryInformation,
    data.shipmentKey,
    userId,
  );
  newData.shipmentAccessorialInformation = data.accessorials
    ? data?.accessorials?.map((row) => ({
        shipmentKey: 0,
        accChargeType: row?.codeId,
        accChargeAmount: valueToNumber(row?.accChargeAmount),
        gridOperation: 1,
        codeDesc: valueToString(row?.codeDesc),
        lookupKey: valueToNumber(row?.lookupKey),
        createdBy: userId,
        createdOn: moment(new Date()),
      }))
    : [];
  newData.shipmentTaxInformation = data.taxes
    ? data?.taxes?.map((row, index) => ({
        shipmentKey: 0,
        sequence: index + 1,
        taxAmount: valueToNumber(row?.taxAmount),
        taxTypeCode: valueToString(row?.taxTypeCode),
        createdBy: userId,
        createdOn: moment(new Date()),
        gridOperation: 2,
      }))
    : [];

  newData.shipmentRateShopInformation =
    data?.shipmentRateShopInformation?.length > 0 ? data?.shipmentRateShopInformation : [];

  return newData;
};

const convertCategoryLocalToAPI = (data, shipmentKey, userId) => {
  const newData = [];

  data?.forEach((row) => {
    newData.push({
      createdBy: valueToNumber(userId),
      shipmentKey: valueToNumber(shipmentKey),
      hierLookupKey: valueToNumber(nullToValue(row.hierLookupKey)),
      hierLookupDetKeyParent: valueToNumber(nullToValue(row.hierLookupDetKeyParent)),
      hierLookupDetKey: valueToNumber(nullToValue(row.hierLookupDetKey)),
      gridOperation: valueToNumber(nullToValue(row.gridOperation)),
      hierLookupDetNameParent: valueToString(row.hierLookupDetNameParent),
      hierLookupDetName: valueToString(row.hierLookupDetName),
      heirDetSequence: valueToNumber(nullToValue(row.heirDetSequence)),
      shipmentHierarchyDetailsId: valueToNumber(nullToValue(row.shipmentHierarchyDetailsId)),
      hierLookupName: valueToString(row.hierLookupName),
    });
  });

  return newData;
};

const convertVendorLocalToAPI = (data, shipmentKey, userId) => {
  const newData = [];
  data?.forEach((row) => {
    newData.push({
      shipmentKey: valueToNumber(shipmentKey),
      vendorKey: valueToNumber(row.vendorKey),
      vendorName: valueToString(row.vendorName),
      vendorPhone: valueToString(row.vendorPhone),
      vendorEmail: valueToString(row.vendorEmail),
      city: valueToString(row.city),
      stateCode: valueToString(row.stateCode),
      postalCode: valueToString(row.postalCode),
      countryCode: valueToString(row.countryCode),
      createdBy: valueToNumber(data.isNew ? userId : data.createdBy),
      gridOperation: valueToNumber(row.gridOperation),
      id: valueToNumber(row.id),
      countryName: valueToString(row.countryName),
      stateName: valueToString(row.stateName),
    });
  });

  return newData;
};

const convertAdditionalDetailsLocalToAPI = (
  data,
  mainData,
  customerKey,
  shipmentKey,
  shipmentNo,
  userId,
  approvalNumber,
  masterShipment,
) => {
  if (!data) {
    return {};
  }
  const newData = {
    shipmentKey: shipmentKey,
    shipmentNo: valueToString(shipmentNo),
    approvalNumber: valueToString(approvalNumber),
    masterShipment: masterShipment === true ? 1 : 0,
    status: data.status,
    customerKey: customerKey,
    branchKey: data.branchKey,
    accountNumber: data.accountNumber,
    fobCode: data.fobCode,
    freightAllowance: data.freightAllowance,
    shipmentType: data.shipmentType,
    shipmentTerms: data.shipmentTerms,
    incoCode: data.incoCode?.trim(),
    incoPoint: data.incoPoint,
    customerContact: data.customerContact,
    createdBy: userId,
    currencyCode: data.currencyCode,
    bolNumber: data.bolNumber,
    proNo: data.proNo,
    masterBolNumber: data.masterBolNumber,
    trailerNumber: data.trailerNumber,
    shipmentNotes: valueToString(mainData.shipmentNotes),
    detailNotes: valueToString(mainData.detailNotes),
    carrierRequirements: valueToString(mainData.carrierRequirements),
    cargoType: valueToString(mainData.cargoType?.[0]),
    serviceKey: valueToNumber(mainData.serviceKey),
    requiredCarrierKey: valueToNumber(mainData.requiredCarrierKey),
    trailerId: valueToNumber(mainData.trailerKey),
    purchaseOrderNumber: valueToString(data.purchaseOrderNumber),
    salesOrderNumber: valueToString(data.salesOrderNumber),
    paidAmount: valueToNumber(data.paidAmount),
    paymentTerms: valueToString(data.paymentTerms),
    quoteNo: '',
    projectNo: '',
    expShipDate: '2022-09-05T10:46:14.373Z',
    expDeliveryDate: '2022-09-05T10:46:14.373Z',
    specialServices: '',
    rateShopCost: 0,
    transportationMode: '',
    carrierKey: 0,
    trackingDateTime: '2022-09-05T10:46:14.373Z',
    masterShipmentCurrentWeight: 0,
    rateShopKey: 0,
    masterShipmentCurrentQty: 0,
  };

  return newData;
};

const convertProductLocalToAPI = (_data, shipmentKey, userId) => {
  let data = _data || [];
  data = data.map(({ createdBy, ...row }) => ({
    createdBy: valueToNumber(row.shipmentDetailsID ? createdBy : userId),
    shipmentKey: valueToNumber(shipmentKey),
    shipmentDetailsID: valueToNumber(row.shipmentDetailsID),
    itemSequenceKey: valueToNumber(row.itemSequenceKey),
    productCode: valueToString(row.productCode),
    quantity: valueToNumber(row.quantity),
    unitMeasure: valueToString(row.unitMeasure),
    unitPrice: valueToNumber(row.unitPrice),
    productDescription: valueToString(row.productDescription),
    palletLoadType: valueToString(row.palletLoadType),
    weight: valueToNumber(row.weight),
    weightUom: valueToString(row.weightUom),
    billQty: valueToNumber(row.billQty),
    billQtyUom: valueToString(row.billQtyUom),
    length: valueToNumber(row.length),
    width: valueToNumber(row.width),
    height: valueToNumber(row.height),
    dimUom: valueToString(row.dimUom),
    cube: valueToNumber(valueToNull(row.cube)),
    class: valueToString(row.class),
    poNumber: valueToString(row.poNumber),
    soNumber: valueToString(row.soNumber),
    reference1: valueToString(row.reference1),
    crateNo: valueToString(row.crateNo),
    nmfcNumber: valueToString(row.nmfcNumber),
    gridOperation: valueToNumber(row.gridOperation),
    hazmat: valueToString(row.hazmat),
    hazmatUnNo: valueToString(row.hazmatUnNo),
    unitMeasureName: valueToString(row.unitMeasureName),
    className: valueToString(row.className),
    weightUomName: valueToString(row.weightUomName),
    dimUomName: valueToString(row.dimUomName),
    billQtyUomName: valueToString(row.billQtyUomName),
    hts: valueToString(row.hts),
    eccn: valueToString(row.eccn),
    countryOfOrigin: valueToString(row.countryOfOrigin),
    stcDescription: valueToString(row.stcDescription),
    palletPackageType: valueToString(row.palletPackageType),
    bookOks: valueToNumber(row.bookOks),
    book: valueToNumber(row.book),
    soft: valueToNumber(row.soft),
    softOks: valueToNumber(row.softOks),
    misc: valueToNumber(row.misc),
    miscOKs: valueToNumber(row.miscOKs),
    cartonQty: 0,
    cartonUOM: '',
    actualWeight: 0,
    deliveryID: '',
  }));
  return data;
};
const convertTransportationListLocalToAPI = (data, userID, customerKey) => {
  const newData = {
    shipmentOriginInformation: [],
    shipmentDestinationInformation: [],
  };

  data?.forEach(({ stopType, portRecKey, ...row }) => {
    const params =
      Number(stopType) === SHIPMENT_TRANSPORTATION_TYPES[SHIPMENT_TRANSPORTATION_OBJECTS.PICKUP]
        ? {
            key: 'originKey',
            additionalInfo: 'shipmentOriginAdditionalInformation',
            requestedDate: 'shipperRequestedShipDate',
            actualDate: 'carrierActualShipDate',
            appointmentDate: 'carrierAppontmentShipDate',
          }
        : {
            key: 'destinationKey',
            additionalInfo: 'shipmentDestinationAdditionalInformation',
            requestedDate: 'shipperRequestedDeliveryDate',
            actualDate: 'carrierActualDeliveryDate',
            appointmentDate: 'carrierAppontmentDeliveryDate',
          };
    newData[SHIPMENT_TRANSPORTATION_ADDITIONAL_INFO_POST[SHIPMENT_TRANSPORTATION_TYPES_ID[stopType]]].push({
      shipmentKey: row.shipmentKey,
      displaySequence: valueToNumber(nullToValue(row.displaySequence)),
      sequence: valueToNumber(nullToValue(row.sequence)),
      legNumber: row.legNumber,
      stopType: stopType,
      shipRecKey: row.shipRecKey,
      customerKey: customerKey,
      name: row.name,
      addr1: row.address1,
      addr2: row.address2,
      city: row.city,
      state: row.stateCode,
      zip: row.zipCode,
      countryCode: row.countryCode,
      searchId: row.searchId,
      createdBy: nullToValue(userID),
      oldStopSequence: nullToValue(row.oldStopSequence),
      portType: row.portType,
      portRecKey: nullToValue(valueToNumber(portRecKey)),
      gridOperation: nullToValue(row.gridOperation),
      [params.additionalInfo]: {
        shipmentKey: row.shipmentKey,
        displaySequence: valueToNumber(nullToValue(row.displaySequence)),
        sequence: valueToNumber(nullToValue(row.sequence)),
        [params.requestedDate]: row.requestedDate
          ? getFormattedTimeString(convertLocalToEST(dateTimeToSingleValue(row.requestedDate, row.requestedTime)))
          : null,
        [params.appointmentDate]: row.appointmentDate
          ? getFormattedTimeString(convertLocalToEST(dateTimeToSingleValue(row.appointmentDate, row.appointmentTime)))
          : null,
        [params.actualDate]: row.actualDate
          ? getFormattedTimeString(convertLocalToEST(dateTimeToSingleValue(row.actualDate, row.actualTime)))
          : null,

        pickupDeliveryID: row.appointmentNo,
        doorDockID: row.doorDockID,
        contactName: row.contactName,
        contactEmail: row.contactEmail,
        phone: row.phone,
        createdBy: nullToValue(userID),
        hoursOfOperation: `${valueToString(row.fromOperationDay)} TO ${valueToString(
          row.toOperationDay,
        )} | ${convertOperationHoursTime(
          row.fromOperationHours,
        )} TO ${convertOperationHoursTime(row.toOperationHours)}`,
        appointmentType: row.appointmentType,
        gridOperation: nullToValue(row.gridOperation),
        oldStopSequence: row.oldStopSequence,
        isResetNew: row.isResetNew,
        uom: row.uom,
        legMiles: row.legMiles,
        extension: row.extension,
        dockNumber: row.dockNumber,
        taxId: row.taxId,
      },
      countryName: row.countryName,
      stateName: row.stateName,
      portName: row.portName,
      isResetNew: row.isResetNew,
      trailerNumber: valueToString(row.trailerNumber),
    });
  });

  return newData;
};

const convertDocumentsLocalToApiForAddShipment = (data) => {
  return data
    ? data.map((row, index) => ({
        documentSequence: index + 1,
        documentTitle: valueToString(row.documentTitle),
        documentFileName: valueToString(row.file),
        documentDesc: valueToString(row.documentDesc),
        originalFileName: valueToString(row.file),
        documentTypeCode: valueToString(row.docTypeCode),
        filePath: row?.fileBase64?.trim() !== '' ? row.fileBase64.split(',')[1] : '',
        referenceNo: valueToString(row.referenceNo),
        fileExtension: `.${valueToString(row.file).split('.').pop()}`,
        isVendorVisible: !!row.isVendorVisible,
        isCarrierVisible: !!row.isCarrierVisible,
      }))
    : [];
};
const convertOperationHoursTime = (time) => {
  if (time) {
    return time.format('hh:mm A');
  }
  return ' ';
};

const convertBillLocaltoAPI = (data, shipmentKey, userId) => {
  return {
    shipmentKey: shipmentKey,
    name: valueToString(data?.name),
    vatNumber: valueToString(data?.vatNumber),
    address1: valueToString(data?.address1),
    address2: valueToString(data?.address2 ? data?.address2 : ' '),
    city: valueToString(data?.city),
    stateCode: valueToString(data?.stateCode),
    postalCode: valueToString(data?.postalCode),
    countryCode: valueToString(data?.countryCode),
    contact: valueToString(data?.contact),
    contactEmail: valueToString(data?.contactEmail),
    createdBy: userId,
    countryName: valueToString(data?.countryName),
    stateName: valueToString(data?.stateName),
  };
};

const fixedData = {
  shipmentDocumentInformation: [],
  purchaseSalesOrderInformation: [],
};

export const calculateSequenceAndDisplaySequence = (_transportationList) => {
  let transportationList = _transportationList || [];
  const totalPickups = transportationList?.filter(({ sequence }) => sequence === '1').length;
  const totalDeliveries = transportationList?.filter(({ sequence }) => sequence === '99').length;

  const destinationIndex = transportationList?.findIndex(({ sequence }) => sequence === '99');
  const newItemIndex = transportationList?.findIndex(({ isNew }) => isNew);
  let newItemSequence = 0;
  const newItemDisplaySequence = transportationList.length - (totalDeliveries > 0 ? 1 : 0);

  const getSequence = (index, isPickup) => {
    if (isPickup) {
      const pickupIndex = index >= 0 ? index : transportationList.length;
      return valueToNumber(transportationList[pickupIndex - 1].sequence) + 1;
    }
    return valueToNumber(transportationList[index - 1].sequence) + 1;
  };

  if (newItemIndex >= 0) {
    if (
      Number(transportationList[newItemIndex].stopType) ===
      SHIPMENT_TRANSPORTATION_TYPES[SHIPMENT_TRANSPORTATION_OBJECTS.PICKUP]
    ) {
      newItemSequence = totalPickups > 0 ? getSequence(destinationIndex, true) : '1';
    } else {
      newItemSequence = totalDeliveries > 0 ? getSequence(destinationIndex, true) : '99';
    }
  }

  transportationList[newItemIndex] = {
    ...transportationList[newItemIndex],
    sequence: valueToString(newItemSequence),
    displaySequence: valueToString(newItemDisplaySequence),
  };

  if (totalDeliveries > 0) {
    transportationList[destinationIndex] = {
      ...transportationList[destinationIndex],
      displaySequence: valueToString(transportationList.length),
    };
  }

  let sequence = 0;
  transportationList = transportationList.map((row) => {
    if (Number(row.sequence) !== 99) {
      sequence += 1;
    }
    return {
      ...row,
      sequence: Number(row.sequence) === 99 ? 99 : sequence,
    };
  });
  return transportationList;
};

export const calculateSequenceAndDisplaySequenceForEdit = (transportationList) => {
  const newStopIndex = transportationList?.findIndex(({ gridOperation }) => gridOperation === 1);

  if (newStopIndex >= 0) {
    const highestSequence = maxBy(
      transportationList?.filter(
        ({ stopType, sequence }) => stopType === transportationList[newStopIndex].stopType && sequence >= 0,
      ),
      ({ sequence }) => sequence,
    );

    transportationList[newStopIndex].sequence = Number(highestSequence.sequence ? highestSequence.sequence : 0) + 1;
    transportationList[newStopIndex].displaySequence = transportationList?.length - 1;
  }

  return transportationList;
};

export const convertIRateShopApiResponseToLocal = (_data) => {
  let data = _data || [];
  if (data) {
    data = data.map((row) => ({
      accessorials: row?.accessorials
        ? row?.accessorials?.map((accRow) => ({
            auditedChargeAmount: accRow?.auditedChargeAmount,
            description: accRow?.description,
            currencyCode: accRow?.currencyCode,
            accessorialCode: accRow?.accessorialCode,
          }))
        : [],
      cargoType: row.cargoType,
      carrierKey: row.carrierKey,
      carrierName: row.carrierName,
      currencyCode: row.currencyCode,
      directPoint: row.directPoint,
      error_message: row.errorMessage,
      mileage: row.mileageMiles,
      mileageKm: row.mileageKilometers,
      pricingBasis: row.pricingBasis,
      pricingType: row.pricingType,
      serviceDesc: row.serviceDescription,
      serviceKey: row.serviceKey,
      serviceType: row.serviceCode,
      shipmentCost: row.shipmentCost,
      standardDaysTransit: row.standardDaysTransit,
      trailerDesc: row.trailerDescription,
      equipmentTypeDetail: row.trailerDescription,
      trailerkey: row.trailerKey,
      convertedCost: row.convertedCost,
      freightAccessorialCollection: row.accessorials,
      convertedCurrencyCode: row.convertedCurrency,
      spotQuoteNumber: row.spotQuoteContractNumber,
      bidComment: row.errorMessage,
      effectiveTo: convertDateToMoment(row.pricingEffectiveTo),
      createdOn: moment(new Date()),
      TariffKey: row.tariffKey,
      pricingDetailKey: row.pricingKey,
      accessorialCost: sum(
        row.accessorials ? row.accessorials.map(({ AuditedChargeAmount }) => AuditedChargeAmount) : [],
      ),
      rateShopKey: '',
      rateType: '',
      flagStandardTranit: '',
      viewCargoType: null,
      isRateEntry: null,
      totalShipmentCost: row.totalShipmentCost,
    }));
  }
  data = data.filter(({ totalShipmentCost }) => {
    return Number(totalShipmentCost) > 0;
  });
  data = orderBy(data, ['totalShipmentCost'], ['asc']);
  return data;
};

export const convertRateEngineApiResponseToShipmentLocal = (_data, isAPIRateShop) => {
  let data = _data || _data;
  if (data) {
    data = data.map((row) => ({
      accessorials: [
        {
          auditedChargeAmount: row.ABSTotalCharge,
          description: 'FREIGHT CHARGE',
          currencyCode: row?.CurrencyCode,
          accessorialCode: 'FREIGHT',
        },
        ...orderBy(
          row?.Accessorials
            ? // eslint-disable-next-line no-unsafe-optional-chaining
              row?.Accessorials?.map((accRow) => ({
                auditedChargeAmount: accRow?.AuditedChargeAmount,
                description: accRow?.Description,
                currencyCode: accRow?.CurrencyCode,
                accessorialCode: accRow?.AccessorialCode,
              }))
            : [],
          ['description'],
          ['asc'],
        ),
      ],
      cargoType: row.CargoType,
      carrierKey: row.CarrierKey,
      carrierName: row.CarrierName,
      currencyCode: row.CurrencyCode,
      directPoint: row.DirectPoint,
      error_message: row.ErrorMessage,
      mileage: row.MileageMiles,
      mileageKm: row.MileageKilometers,
      pricingBasis: isAPIRateShop ? 'API' : row.PricingBasis,
      pricingType: row.PricingType,
      serviceDesc: row.ServiceDescription,
      serviceKey: row.ServiceKey,
      serviceType: row.ServiceCode,
      shipmentCost: row.ShipmentCost,
      standardDaysTransit: row.StandardDaysTransit,
      trailerDesc: row.TrailerDescription,
      equipmentTypeDetail: row.TrailerDescription,
      trailerkey: row.TrailerKey,
      freightAccessorialCollection: row.Accessorials,
      convertedCurrencyCode: row.CurrencyCode,
      spotQuoteNumber: row.SpotQuoteContractNumber,
      bidComment: row.ErrorMessage,
      effectiveTo: convertDateToMoment(row.PricingEffectiveTo),
      createdOn: moment(new Date()),
      TariffKey: row.TariffKey,
      pricingDetailKey: row.PricingKey,
      accessorialCost: sum(
        row.Accessorials ? row.Accessorials.map(({ AuditedChargeAmount }) => AuditedChargeAmount) : [],
      ),
      rateShopKey: '',
      rateType: '',
      flagStandardTranit: '',
      viewCargoType: null,
      isRateEntry: null,
      totalShipmentCost: valueToNumber(row.TotalShipmentCost),
      convertedCost: valueToNumber(row.TotalShipmentCost),
      CurrencyExchangeRate: row.CurrencyExchangeRate,
      RatedCurrencyCode: row.RatedCurrencyCode,
      RatedTransportProviderCharge: row.RatedTransportProviderCharge,
      CurrencyConversion: row.CurrencyConversion,
    }));
  }
  data = data.filter(({ totalShipmentCost }) => {
    return Number(totalShipmentCost) > 0;
  });
  data = orderBy(data, ['totalShipmentCost'], ['asc']);
  return data;
};

export const prmShipmentTransportation = (data, userID, customerKey) => {
  const newData = [];

  data?.forEach(({ stopType, portRecKey, ...row }) => {
    const params =
      Number(stopType) === SHIPMENT_TRANSPORTATION_TYPES[SHIPMENT_TRANSPORTATION_OBJECTS.PICKUP]
        ? {
            key: 'originKey',
            requestedDate: 'prmShipperRequestedShipDate',
            actualDate: 'prmCarrierActualShipDate',
            appointmentDate: 'prmCarrierAppontmentShipDate',
          }
        : {
            key: 'destinationKey',
            requestedDate: 'prmShipperRequestedDeliveryDate',
            actualDate: 'prmCarrierActualDeliveryDate',
            appointmentDate: 'prmCarrierAppontmentDeliveryDate',
          };
    newData.push({
      [params.requestedDate]: getFormattedTimeString(
        convertLocalToEST(dateTimeToSingleValue(row.requestedDate, row.requestedTime)),
      ),
      [params.appointmentDate]: getFormattedTimeString(
        convertLocalToEST(dateTimeToSingleValue(row.appointmentDate, row.appointmentTime)),
      ),
      [params.actualDate]: getFormattedTimeString(
        convertLocalToEST(dateTimeToSingleValue(row.actualDate, row.actualTime)),
      ),
      prmShipperConsigneeKey: nullToValue(valueToNumber(row.primaryKey)),
      prmSequence: valueToNumber(nullToValue(row.sequence)),
      prmDisplaySequence: valueToNumber(nullToValue(row.displaySequence)),
      prmLegNumber: valueToNumber(row.legNumber),
      prmPortRecKey: nullToValue(valueToNumber(portRecKey)),
      prmStopType: valueToString(stopType),
      prmOperation: valueToNumber(nullToValue(row.gridOperation)),
      prmPortType: valueToString(row.portType),
      prmDoorDockID: valueToString(row.doorDockID),
      prmPickupDeliveryID: valueToString(row.appointmentNo),
      prmContactName: valueToString(row.contactName),
      prmContactEmail: valueToString(row.contactEmail),
      prmPhone: valueToString(row.phone),
      prmHoursOfOperation: `${valueToString(
        row.fromOperationDay,
      )} TO ${valueToString(row.toOperationDay)} | ${convertOperationHoursTime(
        row.fromOperationHours,
      )} TO ${convertOperationHoursTime(row.toOperationHours)}`,
      prmAppointmentType: valueToString(row.appointmentType),
      prmUom: valueToString(row.uom),
      prmLegMiles: valueToNumber(row.legMiles),
      prmDockNumber: valueToString(row.dockNumber),
      prmExtension: valueToString(row.extension),
      prmTaxId: valueToString(row.taxId),
      customerKey: valueToNumber(customerKey),
      name: valueToString(row.name),
      addr1: valueToString(row.address1),
      addr2: valueToString(row.address2),
      city: valueToString(row.city),
      state: valueToString(row.stateCode),
      zip: valueToString(row.zipCode),
      countryCode: valueToString(row.countryCode),
      searchId: valueToString(row.searchId),
      prmModifiedBy: nullToValue(userID),
      isChangeLocationDetails: valueToNumber(row.isChangeLocationDetails),
      trailerNumber: valueToString(row.trailerNumber),
      isModifiedDateTime: valueToNumber(row.isModifiedDateTime),
    });
  });
  return newData;
};

export const prmShipmentAdditionalDetails = (data) => {
  return {
    shipmentKey: data.shipmentKey,
    customerKey: data.customerKey,
    branchKey: data.branchKey,
    accountNumber: data.accountNumber,
    fobCode: data.fobCode,
    freightAllowance: data.freightAllowance,
    shipmentType: data.shipmentType,
    shipmentTerms: data.shipmentTerms,
    incoCode: valueToString(data.incoCode)?.trim(),
    incoPoint: data.incoPoint,
    rateShopCost: valueToNumber(data.shipmentCost),
    customerContact: valueToString(data.customerContact),
    currencyCode: data.currencyCode,
    bolNumber: data.bolNumber,
    proNo: data.proNo,
    masterBolNumber: data.masterBolNumber,
    trailerNumber: data.trailerNumber,
    trailerId: valueToNumber(data.trailerKey),
    rateType: data.status,
    modifiedBy: data.userId,
    poNumber: valueToString(data.purchaseOrderNumber),
    soNumber: valueToString(data.salesOrderNumber),
    paidAmount: valueToNumber(data.paidAmount),
    paymentTerms: valueToString(data.paymentTerms),
    rateShopKey: 0,
    projectNo: '',
    masterShipment: data?.masterShipment ? 1 : 0,
    cargoType: valueToString(data.cargoType),
  };
};

export const prmShipmentProductDetails = (data) => {
  const nextItemSequence = maxBy(data, (o) => o.itemSequenceKey)?.itemSequenceKey;
  return data.map((row) => ({
    itemSequenceKey: row.gridOperation === 1 ? nextItemSequence + 1 : row?.itemSequenceKey,
    quantity: valueToNumber(row.quantity),
    unitMeasure: valueToString(row.unitMeasure),
    productCode: valueToString(row.productCode),
    productDescription: valueToString(row.productDescription),
    class: valueToString(row.class),
    length: valueToNumber(row.length),
    height: valueToNumber(row.height),
    width: valueToNumber(row.width),
    dimUom: valueToString(row.dimUom),
    weight: valueToNumber(row.weight),
    weightUom: valueToString(row.weightUom),
    cube: valueToNumber(valueToNull(row.cube)),
    billQty: valueToNumber(row.billQty),
    billQtyUom: valueToString(row.billQtyUom),
    modifedBy: 0,
    stcDescription: valueToString(row.stcDescription),
    hazmatUnNo: valueToString(row.hazmatUnNo),
    hazmat: valueToString(row.hazmat),
    poNumber: valueToString(row.poNumber),
    soNumber: valueToString(row.soNumber),
    reference1: valueToString(row.reference1),
    palletLoadType: valueToString(row.palletLoadType),
    shipmentDetailsID: valueToNumber(row.shipmentDetailsID),
    crateNo: valueToString(row.crateNo),
    unitPrice: valueToNumber(row.unitPrice),
    nmfcNumber: valueToString(row.nmfcNumber),
    eccn: valueToString(row.eccn),
    countryOfOrigin: valueToString(row.countryOfOrigin),
    hts: valueToString(row.hts),
    operation: valueToNumber(row.gridOperation),
    deliveryID: valueToString(row.deliveryID),
    actualWeight: valueToNumber(row.actualWeight),
    cartonQty: valueToNumber(row.cartonQty),
    cartonUOM: valueToString(row.cartonUOM),
    bookOks: valueToNumber(row.bookOks),
    book: valueToNumber(row.book),
    soft: valueToNumber(row.soft),
    softOks: valueToNumber(row.softOks),
    misc: valueToNumber(row.misc),
    miscOKs: valueToNumber(row.miscOKs),
  }));
};

export const prmShipmentProductDetailsSingle = (data) => ({
  itemSequenceKey: data.gridOperation === 1 ? 0 : data?.itemSequenceKey,
  quantity: valueToNumber(data.quantity),
  unitMeasure: valueToString(data.unitMeasure),
  productCode: valueToString(data.productCode),
  productDescription: valueToString(data.productDescription),
  class: valueToString(data.class),
  length: valueToNumber(data.length),
  height: valueToNumber(data.height),
  width: valueToNumber(data.width),
  dimUom: valueToString(data.dimUom),
  weight: valueToNumber(data.weight),
  weightUom: valueToString(data.weightUom),
  cube: valueToNumber(valueToNull(data.cube)),
  billQty: valueToNumber(data.billQty),
  billQtyUom: valueToString(data.billQtyUom),
  modifedBy: 0,
  stcDescription: valueToString(data.stcDescription),
  hazmatUnNo: valueToString(data.hazmatUnNo),
  hazmat: valueToString(data.hazmat),
  poNumber: valueToString(data.poNumber),
  soNumber: valueToString(data.soNumber),
  reference1: valueToString(data.reference1),
  palletLoadType: valueToString(data.palletLoadType),
  shipmentDetailsID: valueToNumber(data.shipmentDetailsID),
  crateNo: valueToString(data.crateNo),
  unitPrice: valueToNumber(data.unitPrice),
  nmfcNumber: valueToString(data.nmfcNumber),
  eccn: valueToString(data.eccn),
  countryOfOrigin: valueToString(data.countryOfOrigin),
  hts: valueToString(data.hts),
  operation: valueToNumber(data.gridOperation),
  deliveryID: valueToString(data.deliveryID),
  actualWeight: valueToNumber(data.actualWeight),
  cartonQty: valueToNumber(data.cartonQty),
  cartonUOM: valueToString(data.cartonUOM),
  palletPackageType: valueToString(data.palletPackageType),
  bookOks: valueToNumber(data.bookOks),
  book: valueToNumber(data.book),
  soft: valueToNumber(data.soft),
  softOks: valueToNumber(data.softOks),
  misc: valueToNumber(data.misc),
  miscOKs: valueToNumber(data.miscOKs),
});

export const prmShipmentBillingDetails = (data) => {
  return {
    shipmentKey: data.shipmentKey,
    name: valueToString(data?.name),
    vatNumber: valueToString(data?.vatNumber),
    address1: valueToString(data?.address1),
    address2: valueToString(data?.address2 ? data?.address2 : ''),
    city: valueToString(data?.city),
    stateCode: valueToString(data?.stateCode),
    postalCode: valueToString(data?.postalCode),
    countryCode: valueToString(data?.countryCode),
    contact: valueToString(data?.contact),
    contactEmail: valueToString(data?.contactEmail),
    modifiedBy: data.userId,
  };
};

export const prmShipmentVendorDetails = (data, shipmentKey, userId) => {
  return data.map((row) => ({
    shipmentKey: valueToNumber(shipmentKey),
    id: valueToNumber(row.id),
    vendorKey: valueToNumber(row.vendorKey),
    vendorName: valueToString(row.vendorName),
    vendorPhoneNumber: valueToString(row.vendorPhone),
    vendorEmail: valueToString(row.vendorEmail),
    city: valueToString(row.city),
    stateCode: valueToString(row.stateCode),
    postalCode: valueToString(row.postalCode),
    countryCode: valueToString(row.countryCode),
    modifiedBy: userId,
    operation: valueToNumber(row.gridOperation),
  }));
};

export const prmShipmentCategory = (data, userId) => {
  return data.map((row, index) => ({
    hierDetSequence: valueToNumber(index + 1),
    hierLookupDetKey: valueToNumber(nullToValue(row.hierLookupDetKey)),
    hierLookupDetKeyParent: valueToNumber(nullToValue(row.hierLookupDetKeyParent)),
    modifiedBy: userId,
  }));
};

export const shipmentSpotBidDataToLocal = (data) => {
  return data.map((row) => ({
    ...row,
    convertedCost: row.cost,
    userCreatedBy: row.createdByName,
    effectiveTo: row.bidExpiryTime,
    standardDaysTransit: row.standardTransitDays,
    createdOn: convertDateESTToUTCToUserLocal(row.createdOn),
  }));
};

export const shipmentTrackApiToLocal = (data) => {
  if (data?.length > 0) {
    return trimObjectValues(
      data.map((row) => ({
        ...row,
        carrierShipDate: convertDateStringtoMoment(row.carrierShipDate),
        carrierShipTime: convertDateStringtoMoment(row.carrierShipDate),
        carrierDeliveryDate: convertDateStringtoMoment(row.carrierDeliveryDate),
        carrierDeliveryTime: convertDateStringtoMoment(row.carrierDeliveryDate),
        shipperRequestedShipDate: convertDateToMoment(row.shipperRequestedShipDate, 'M/D/YYYY hh:mm:ss A'),
        shipperRequestedDeliveryDate: convertDateToMoment(row.shipperRequestedDeliveryDate, 'M/D/YYYY hh:mm:ss A'),
        dateTimeAtStatusDate: convertDateStringtoMoment(row.dateTimeAtStatus),
        dateTimeAtStatusTime: convertDateStringtoMoment(row.dateTimeAtStatus),
        dateTimeStamp: convertDateStringtoMoment(row.dateTimeStamp),
      })),
    );
  }
  return [];
};

export const convertShipmentRackingLocalToAPI = (data) => {
  const carrierShipDate = combineDateTimeMoment(data?.carrierShipDate, data?.carrierShipTime);
  const dateTimeAtStatus = combineDateTimeMoment(data?.dateTimeAtStatusDate, data?.dateTimeAtStatusTime);

  return {
    shipmentNumber: valueToString(data?.shipmentNumber),
    iCountryCode: valueToString(data?.iCountryCode),
    iStateCode: valueToString(data?.iStateCode),
    iCity: valueToString(data?.iCity),
    statusCode: valueToString(data?.statusCode),
    statusTypeCode: valueToString(data?.statusTypeCode),
    exceptionTypeCode: valueToString(data?.exceptionTypeCode),
    signature: valueToString(data?.signature),
    trackSequenceKey: null,
    userCreatedBy: valueToNumber(data?.userCreatedBy),
    carrierShipDate: carrierShipDate?.toJSON(),
    dateTimeAtStatus: dateTimeAtStatus?.toJSON(),
    timeZone: valueToString(moment().tz(moment.tz.guess()).format('z')),
    shipmentTrackKey: valueToNumber(data?.shipmentTrackKey),
    dateTimeStamp: data?.dateTimeStamp?.toJSON(),
    timeAtStatus: dateTimeAtStatus?.format('M/D/YYYY hh:mm:ss A'),
    shipTime: formateWithMoment(data?.shipperRequestedShipDate, 'hh:mm A'),
    eventLocalTime: formateWithMoment(data?.dateTimeAtStatus, 'hh:mm A'),
    delivaryTime: formateWithMoment(data?.carrierDeliveryDate, 'hh:mm A'),
    carrierDeliveryDate: combineDateTimeMoment(data?.carrierDeliveryDate, data?.carrierDeliveryTime)?.toJSON(),
    entryDateTime: null,
  };
};

export const shipmentAddressBookListApiToLocal = (data) => {
  if (data?.length > 0) {
    return data.map((row) => {
      const phoneSplitted = row?.phone?.split('-');
      const countryCallingCode = phoneSplitted?.length > 1 ? phoneSplitted[0] : '';
      const phone = phoneSplitted?.length > 1 ? phoneSplitted[1] : phoneSplitted[0];
      const daysOfWeek = row?.daysOfWeek?.split('-');
      const hoursOfOperation = row?.hoursOfOperation?.split('-');
      return trimObjectValues({
        ...row,
        countryCallingCode: countryCallingCode,
        phone: phone,
        fromOperationDay: daysOfWeek?.[0],
        toOperationDay: daysOfWeek?.[1],
        fromOperationHours: convertTimetoMoment(hoursOfOperation?.[0]),
        toOperationHours: convertTimetoMoment(hoursOfOperation?.[1]),
      });
    });
  }
  return [];
};

export const convertRateShopResponseToAPI = (data, customerKey, selectedCarrierKey) => {
  if (data?.length > 0) {
    return data.map((row) => ({
      totalShipmentCost: row.totalShipmentCost ? row.totalShipmentCost : row.shipmentCost,
      totalAccessorialCharge: row.accessorialCost,
      pricingBasis: row.pricingBasis,
      currencyCode: row.currencyCode,
      pricingType: row.pricingType,
      cargoType: row.cargoType,
      trailerKey: valueToNumber(row.trailerkey) ? valueToNumber(row.trailerkey) : -1,
      serviceKey: row.serviceKey,
      carrierName: row.carrierName,
      carrierKey: row.carrierKey,
      customerKey: customerKey,
      pricingKey: row.pricingDetailKey,
      accessorials: (row.accessorials || [])
        .map(({ auditedChargeAmount, description, accessorialCode, costType, cost, costName }) => ({
          auditedChargeAmount: valueToNumber(auditedChargeAmount ? auditedChargeAmount : cost),
          description: description ? description : costName,
          accessorialCode: accessorialCode ? accessorialCode : costType,
        }))
        .filter(({ accessorialCode }) => accessorialCode !== 'FREIGHT'),

      trailerDescription: row.trailerDesc,
      standardDaysTransit: row.standardDaysTransit,
      directPoint: row.directPoint,
      mileageMiles: row.mileage,
      tariffKey: valueToNumber(row.TariffKey),
      mileageKilometers: row.mileageKm,
      isSelected: selectedCarrierKey === row?.carrierKey ? 1 : 0,
      CurrencyExchangeRate: row.CurrencyExchangeRate,
      RatedCurrencyCode: row.RatedCurrencyCode,
      RatedTransportProviderCharge: row.RatedTransportProviderCharge,
      CurrencyConversion: row.CurrencyConversion,
    }));
  }
};

export const parseCreateQuoteDataFromFormData = (data) => {
  return {
    quoteNo: valueToString(data?.quoteNo),
    projectNo: valueToString(data?.projectNo),
    shipDate: convertUserLocalToEST(data?.shipDate),
    deliveryDate: data.deliveryDate === '' ? null : convertUserLocalToEST(data.deliveryDate),
    branch: valueToString(data?.branch),
    shipmentType: valueToString(data?.shipmentType),
    shipmentTerms: valueToString(data?.shipmentTerms),
    rateShopCost: valueToNumber(data?.rateShopCost),
    currencyCode: valueToString(data?.currencyCode),
    createdBy: valueToNumber(data?.createdBy),
    modifiedBy: valueToString(data?.modifiedBy),
    createdOn: formateWithMoment(data?.createdOn, 'MM/D/yyyy'),
    modifiedOn: formateWithMoment(data?.modifiedOn, 'MM/D/yyyy'),
    shipmentNumber: valueToString(data?.shipmentNumber),
    shipmentKey: valueToNumber(data?.shipmentKey),
    shipmentStatus: data?.shipmentStatus,
    customerKey: valueToNumber(data?.customerKey),
    rateShopKey: 0,
    transportGridModel: data?.stops?.map((row) => ({
      stopTypeID: valueToString(row?.stopTypeID),
      city: valueToString(row?.city),
      postalCode: valueToString(row?.postalCode),
      state: valueToString(row?.state),
      countryCode: valueToString(row?.countryCode),
      portType: valueToString(row?.portType),
      portRecKey: valueToString(row?.portRecKey),
      gridOperation: valueToNumber(row?.gridOperation),
      oldStopSequence: valueToNumber(row?.oldStopSequence),
      stopSequence: valueToNumber(row?.stopSequence),
    })),
    productGridModel: data?.products?.map((row) => ({
      billQtyUom: valueToString(row?.billQtyUom),
      billQty: valueToString(row?.billQty),
      weight: valueToNumber(row?.weight),
      weightUom: valueToString(row?.weightUom),
      length: valueToNumber(row?.length),
      width: valueToNumber(row?.width),
      height: valueToNumber(row?.height),
      dimUom: valueToString(row?.dimUom),
      cube: valueToNumber(row?.cube),
      class: valueToString(row?.class),
      itemSequenceKey: valueToNumber(row?.itemSequenceKey),
      gridOperation: valueToNumber(row?.gridOperation),
      createdBy: valueToNumber(row?.createdBy),
      billQtyUomName: valueToString(row?.billQtyUomName),
      className: valueToString(row?.className),
      dimUomName: valueToString(row?.dimUomName),
      weightUomName: valueToString(row?.weightUomName),
      palletLoadType: 'Non Stackable', // Always use this static
    })),
    accessorialGridModel: data?.accessorials?.map((row) => ({
      accChargeType: valueToString(row?.codeId),
      codeDesc: valueToString(row?.codeDesc),
      isChecked: row?.isChecked ? 1 : 0,
      accChargeAmount: valueToNumber(row?.accChargeAmount),
    })),
    shipmentDocumentInformation: convertDocumentsLocalToApiForAddShipment(data?.documents),
    shipmentNote: data?.shipmentNote,
    cargoType: data.cargoType,
  };
};

export const parseQuoteDataToRateEngine = (data) => {
  let shipmentOrigin = data?.transportGridModel?.filter(({ stopTypeID }) => stopTypeID === '1');
  shipmentOrigin = shipmentOrigin?.[0];
  let shipmentDestination = data?.transportGridModel?.filter(({ stopTypeID }) => stopTypeID === '2');
  shipmentDestination = shipmentDestination?.[shipmentDestination?.length - 1];

  const totalNumberOfPieces = sumBy(data?.productGridModel, ({ billQty }) => valueToNumber(billQty));

  const totalWeight = sumBy(data?.productGridModel, ({ weight }) => valueToNumber(weight));

  const totalClass = maxBy(data?.productGridModel, ({ class: classValue }) => valueToNumber(classValue))?.class;

  const formData = {
    RateShopCriteria: {
      Accessorials: data?.accessorials
        ? data?.accessorials.map((row) => ({
            AccessorialCode: row.accChargeType?.trim(),
            Description: row.codeDesc,
            BilledAmount: 0,
            CurrencyCode: null,
          }))
        : [],
      Details: data?.productGridModel
        ?.filter(({ weight }) => weight > 0)
        .map((product, index) => ({
          SequenceNumber: valueToNumber(index + 1),
          NumberOfPieces: valueToNumber(product.billQty),
          ActualWeight: 0,
          BilledWeight: valueToNumber(product.weight),
          BilledWeightUOM: null,
          RatingClass: valueToString(product.class),
          MeasurementType: valueToString(product.weightUom),
          BilledQuantity: valueToNumber(product.billQty),
          Length: valueToNumber(product.length),
          Width: valueToNumber(product.width),
          Height: valueToNumber(product.height),
          Cube: 0,
          CubeUOM: null,
          ProductCode: '',
          TrailerKey: 0,
        })),
      Lanes: [
        {
          Id: 1,
          LaneKey: 0,
          Origin: {
            Port: {
              Key: valueToNumber(shipmentOrigin?.portRecKey),
              Type: stringToNull(shipmentOrigin?.portType),
              Code: stringToNull(shipmentOrigin?.portCode),
            },
            Key: valueToNumber(shipmentOrigin?.primaryKey),
            Address1: valueToString(shipmentOrigin?.address1),
            Address2: null,
            City: shipmentOrigin?.city,
            StateCode: shipmentOrigin?.state,
            CountryCode: shipmentOrigin?.countryCode,
            Postal: shipmentOrigin?.postalCode,
            PostalTo: null,
            BranchKey: -1,
          },
          Destination: {
            Port: {
              Key: valueToNumber(shipmentDestination?.portRecKey),
              Type: stringToNull(shipmentDestination?.portType),
              Code: stringToNull(shipmentDestination?.portCode),
            },
            Key: valueToNumber(shipmentDestination?.primaryKey),
            Address1: valueToString(shipmentDestination?.address1),
            Address2: null,
            City: shipmentDestination?.city,
            StateCode: shipmentDestination?.state,
            CountryCode: shipmentDestination?.countryCode,
            Postal: shipmentDestination?.postalCode,
            PostalTo: null,
            BranchKey: -1,
          },
          MileageMile: 0,
        },
      ],
      Stops:
        data?.transportGridModel?.length > 2
          ? data?.transportGridModel?.map((row, index) => ({
              LaneId: 1,
              Sequence: valueToNumber(index + 1),
              Type: null,
              ShipRecKey: 0,
              Location: {
                Port: {
                  Key: valueToNumber(row?.portRecKey),
                  Type: stringToNull(row?.portType),
                  Code: stringToNull(row?.portCode),
                },
                Key: 0,
                Address1: valueToString(row.address1),
                Address2: valueToString(row.address2),
                City: valueToString(row.city),
                StateCode: valueToString(row.state),
                CountryCode: valueToString(row.countryCode),
                Postal: valueToString(row.postalCode),
                PostalTo: null,
                BranchKey: -1,
              },
              NumberPieces: totalNumberOfPieces,
              Mileage: 0,
              Weight: totalWeight,
              LegMiles: 0,
              TotalCharge: 0,
              ActualCity: valueToString(row.city),
              ActualState: valueToString(row.state),
              TripMiles: 0,
            }))
          : [],
      Taxes: [],
      CriteriaId: 1,
      Source: 'RateShop',
      AuditType: null,
      CustomerKey: data?.customerKey,
      CarrierKey: '-1',
      BranchKey: data?.branch,
      TrailerKey: -1,
      ShipmentDate: data?.shipDate ? `/Date(${moment(data?.shipDate).valueOf()})/` : null,
      DeliveryDate: `/Date(${moment(data?.deliveryDate ? data?.deliveryDate : data?.shipDate).valueOf()})/`,
      PricingType: 'PACT',
      PricingBasis: '**',
      CurrencyCode: data.currencyCode,
      CargoType: data.cargoType?.length ? data.cargoType.join(',') : '**',
      WeightUnitOfMeasure: data?.productGridModel?.[0]?.weightUom,
      ServiceKey: -1,
      ServiceCode: '**',
      ServiceDescription: '',
      IntercompanyType: valueToString(data?.shipmentTerms),
      DiscountMode: valueToString(data?.shipmentType),
      ShipmentTerms: valueToString(data?.shipmentTerms),
      TimeFrame: 'C',
      TransportationMode: '**',
      LinerCode: null,
      LinerType: null,
      AccountNumber: null,
      IsShipmentRateshop: 'Y',
      PackageBranchKeys: '-1',
      MileageMile: 0,
      MileageKilometer: 0,
      Weight: valueToNumber(sumBy(data?.productGridModel, ({ weight }) => Number(weight))),
      Cube: 0,
      RatingClass: valueToString(totalClass),
      NumberOfPieces: totalNumberOfPieces,
      Length: valueToNumber(sumBy(data?.productGridModel, ({ length }) => Number(length))),
      Width: valueToNumber(sumBy(data?.productGridModel, ({ width }) => Number(width))),
      Height: valueToNumber(sumBy(data?.productGridModel, ({ height }) => Number(height))),
      ProductCode: null,
      Debug: false,
      TaxableValue: 0,
      DeclaredValue: 0,
      CODValue: 0,
      LDMValue: 0,
      ItemLevelRating: false,
      ContractNumber: null,
      FreightChargeBilled: 0,
      TotalAccessorialBilled: 0,
    },
  };
  return formData;
};

export const shipmentRateShopLocalToRateEngineAPI = (
  Accessorials,
  shipmentDetails,
  filterData,
  currencyCode,
  isAPIRateShop,
) => {
  shipmentDetails.transportationList = orderBy(shipmentDetails.transportationList, ['displaySequence'], ['asc']);
  const shipmentOrigin = shipmentDetails.transportationList[0];
  const shipmentDestination = shipmentDetails.transportationList[shipmentDetails.transportationList.length - 1];

  const originList = shipmentDetails.transportationList?.filter(({ stopType }) => stopType === '1');

  const destList = shipmentDetails.transportationList?.filter(({ stopType }) => stopType === '2');

  const getValuesFromMoment = (_value, type) => {
    let value = _value;
    if (typeof value === 'string') {
      value = moment(value);
    }
    return value?.get(type);
  };

  let shipmentDate = moment(originList[0].requestedDate);
  let deliveryDate = moment(destList[destList.length - 1].requestedDate);

  shipmentDate = shipmentDate?.set({
    hour: getValuesFromMoment(originList?.[0]?.requestedTime, 'hour'),
    minute: getValuesFromMoment(originList?.[0]?.requestedTime, 'minute'),
    second: 0,
    millisecond: 0,
  });

  if (destList?.[destList.length - 1]?.requestedTime && deliveryDate) {
    deliveryDate = deliveryDate?.set({
      hour: getValuesFromMoment(destList?.[destList.length - 1]?.requestedTime, 'hour'),
      minute: getValuesFromMoment(destList?.[destList.length - 1]?.requestedTime, 'minute'),
      second: 0,
      millisecond: 0,
    });
  }

  shipmentDetails.shipmentDate = shipmentDate;
  shipmentDetails.deliveryDate = deliveryDate;

  let stops = shipmentDetails?.transportationList;
  if (stops.length === 2) {
    stops = [];
  }

  let isUsAndCanadaShipment = false;
  if (
    (shipmentOrigin.countryCode === 'US' && shipmentDestination.countryCode === 'US') ||
    (shipmentOrigin.countryCode === 'US' && shipmentDestination.countryCode === 'CA') ||
    (shipmentOrigin.countryCode === 'CA' && shipmentDestination.countryCode === 'US')
  ) {
    isUsAndCanadaShipment = true;
  }

  let mainData = {};
  const formData = {
    Accessorials,
    Details: shipmentDetails?.productList
      ?.filter(({ weight }) => weight > 0)
      .map((product, index) => ({
        SequenceNumber: valueToNumber(index + 1),
        NumberOfPieces: valueToNumber(product.quantity),
        ActualWeight: !isAPIRateShop ? 0 : valueToNumber(product.weight),
        BilledWeight: valueToNumber(product.weight),
        BilledWeightUOM: product.weightUom,
        RatingClass: product.class,
        MeasurementType: product.weightUom,
        BilledQuantity: valueToNumber(product.billQty),
        Length: valueToNumber(product.length),
        Width: valueToNumber(product.width),
        Height: valueToNumber(product.height),
        Cube: valueToNumber(product.cube),
      })),
    Lanes: [
      {
        Id: 1,
        LaneKey: 0,
        Origin: {
          Port: {
            Key: valueToNumber(shipmentOrigin.portRecKey),
            Type: stringToNull(shipmentOrigin.portType),
            Code: stringToNull(shipmentOrigin.portCode),
          },
          Key: valueToNumber(shipmentOrigin.primaryKey),
          Address1: shipmentOrigin.address1,
          Address2: null,
          City: shipmentOrigin.city,
          StateCode: isUsAndCanadaShipment ? shipmentOrigin.stateCode : 'NS',
          CountryCode: shipmentOrigin.countryCode,
          Postal: shipmentOrigin.zipCode,
          PostalTo: null,
          BranchKey: valueToNumber(shipmentDetails.branchKey),
        },
        Destination: {
          Port: {
            Key: valueToNumber(shipmentDestination.portRecKey),
            Type: stringToNull(shipmentDestination.portType),
            Code: stringToNull(shipmentDestination.portCode),
          },
          Key: shipmentDestination.primaryKey,
          Address1: shipmentDestination.address1,
          Address2: null,
          City: shipmentDestination.city,
          StateCode: isUsAndCanadaShipment ? shipmentDestination.stateCode : 'NS',
          CountryCode: shipmentDestination.countryCode,
          Postal: shipmentDestination.zipCode,
          PostalTo: null,
          BranchKey: valueToNumber(shipmentDetails.branchKey),
        },
        MileageMile: 0,
      },
    ],
    Stops: stops.map((row, index) => ({
      LaneId: 1,
      Sequence: index + 1,
      Type: null,
      ShipRecKey: valueToNumber(row.primaryKey),
      Location: {
        Port: {
          Key: valueToNumber(row.portRecKey),
          Type: row.portType,
          Code: row.portCode,
        },
        Key: valueToNumber(row.primaryKey),
        Address1: valueToString(row.address1),
        Address2: valueToString(row.address2),
        City: valueToString(row.city),
        StateCode: valueToString(row.stateCode),
        CountryCode: valueToString(row.countryCode),
        Postal: valueToString(row.zipCode),
        PostalTo: null,
        BranchKey: valueToNumber(shipmentDetails.branchKey),
      },
    })),
    Taxes: shipmentDetails?.taxes
      ? shipmentDetails?.taxes.map((row) => ({
          BilledAmount: valueToNumber(row?.taxAmount),
          Description: valueToString(row?.taxTypeDesc),
          TaxCode: valueToString(row.taxTypeCode),
        }))
      : [],
    CriteriaId: 1,
    Source: 'ShipmentRateShop',
    AuditType: null,
    CustomerKey: shipmentDetails.customerKey,
    CarrierKey: filterData.requiredCarrierKey ? filterData.requiredCarrierKey : '-1',
    BranchKey: shipmentDetails.branchKey,
    TrailerKey: filterData.trailerKey ? filterData.trailerKey : -1,
    ShipmentDate: shipmentDetails.shipmentDate ? `/Date(${moment(shipmentDetails.shipmentDate).valueOf()})/` : null,
    DeliveryDate: `/Date(${moment(
      shipmentDetails.deliveryDate ? shipmentDetails.deliveryDate : shipmentDetails.shipmentDate,
    ).valueOf()})/`,
    PricingType: 'PACT',
    PricingBasis: getRateShopStringAll(shipmentDetails.pricingBasis),
    CurrencyCode: currencyCode,
    CargoType: getRateShopStringAll(filterData.cargoType),
    WeightUnitOfMeasure: shipmentDetails.weightUOM,
    ServiceKey: filterData.serviceKey ? valueToNumber(filterData.serviceKey) : -1,
    ServiceCode: '**',

    IntercompanyType: valueToString(shipmentDetails.shipmentTerms),
    DiscountMode: valueToString(shipmentDetails.shipmentType),
    ShipmentTerms: shipmentDetails.shipmentTerms,
    TimeFrame: 'C',
    TransportationMode: '**',
    LinerCode: null,
    LinerType: null,
    AccountNumber: valueToString(shipmentDetails?.accountNumber),
    IsShipmentRateshop: 'Y',
    PackageBranchKeys: '-1',
    MileageMile: shipmentDetails.totalMileage,
    MileageKilometer: shipmentDetails.totalMileage,
    Weight: valueToNumber(shipmentDetails.shipmentTotalWeight),
    Cube: valueToNumber(shipmentDetails.totalCube),
    ProductCode: null,
    Debug: false,
    TaxableValue: 0,
    DeclaredValue: 0,
    CODValue: 0,
    LDMValue: 0,
    ItemLevelRating: false,
    ContractNumber: null,
    FreightChargeBilled: 0,
    TotalAccessorialBilled: 0,

    havingLeastCost: filterData.carrierRequirements === SHIPMENT_RATE_SHOP_RATTING_PREFERENCES.LEAST_COST, // Internal purpose
  };

  if (isAPIRateShop) {
    mainData = {
      RateQuote: {
        CustomerKey: shipmentDetails.customerKey,
        CarrierKeys: '1107,58,16',
        AccountNos: '13823813,0680281,123456',
        nVision_request: {
          AppsName: null,
          LoginID: null,
          Password: null,
          ApplicationID: 0,
          ConnectionString: null,
          DNSIdentifier: null,
          EndPointAddress: null,
          LicenceKey: null,
          ModuleName: null,
          OwnerID: 0,
          ServiceExpiryDate: null,
          ServiceModuleID: 0,
          UserID: 0,
          UserName: null,
          AccessToken: null,
          Action: null,
          AuthenticationToken: null,
          Debug: false,
          LoadOptions: null,
          RequestId: null,
          Version: null,
          ErrorMessage: null,
          RateShopCriteria: formData,
        },
      },
    };
  } else {
    mainData = { RateShopCriteria: formData };
  }

  return mainData;
};

export const parseStopsForMilageByStops = (stops) => {
  return stops
    ? stops?.map((row) => ({
        Address1: null,
        Address2: null,
        City: row.city,
        StateCode: row.stateCode,
        CountryCode: row.countryCode,
        Postal: row.zipCode,
        Coords: null,
      }))
    : [];
};

export const convertRateShopUiToRateEngine = (data) => {
  return {
    RateShopCriteria: {
      Accessorials: data.accessorials.map(({ codeId, codeDesc }) => ({
        AccessorialCode: codeId,
        Description: codeDesc,
        BilledAmount: 0,
        CurrencyCode: null,
      })),
      Details: data.itemsForm.items.map((row, index) => ({
        SequenceNumber: index + 1,
        NumberOfPieces: valueToNumber(row?.numberOfPieces),
        BilledWeight: valueToNumber(row?.billedWeight),
        BilledWeightUOM: valueToString(data.itemsForm.weightUom),
        RatingClass: valueToNumber(row?.class),
        MeasurementType: valueToString(data.itemsForm.weightUom),
        BilledQuantity: valueToNumber(row?.billQuantity),
        Length: valueToNumber(row?.length),
        Width: valueToNumber(row?.width),
        Height: valueToNumber(row?.height),
        Cube: valueToNumber(row?.cube),
      })),
      Lanes: data.lanes.map((row, index) => ({
        Id: index + 1,
        Origin: {
          Port: {
            Key: row.ORIGIN_portCode ? 1 : 0,
            Type: row.ORIGIN_portType ? row.ORIGIN_portType : null,
            Code: row.ORIGIN_portCode ? row.ORIGIN_portCode : null,
          },
          Key: 0,
          Address1: null,
          Address2: null,
          City: valueToString(row.ORIGIN_city),
          StateCode: valueToString(row.ORIGIN_stateCode),
          CountryCode: valueToString(row.ORIGIN_countryCode),
          Postal: valueToString(row.ORIGIN_postalCode),
          PostalTo: null,
        },
        Destination: {
          Port: {
            Key: row.DEST_portCode ? 1 : 0,
            Type: row.DEST_portType ? row.DEST_portType : null,
            Code: row.DEST_portCode ? row.DEST_portCode : null,
          },
          Key: 0,
          Address1: null,
          Address2: null,
          City: valueToString(row.DEST_city),
          StateCode: valueToString(row.DEST_stateCode),
          CountryCode: valueToString(row.DEST_countryCode),
          Postal: valueToString(row.DEST_postalCode),
          PostalTo: null,
        },
        MileageMile: 0,
      })),
      Stops: data.stops.map((row, index) => ({
        LaneId: row.laneId,
        Sequence: index + 1,
        Type: null,
        ShipRecKey: 0,
        Location: {
          Port: {
            Key: row.portCode ? 1 : 0,
            Type: row.portType ? row.portType : null,
            Code: row.portCode ? row.portCode : null,
          },
          Address1: '',
          Address2: '',
          City: valueToString(row.city),
          StateCode: valueToString(row.stateCode),
          CountryCode: valueToString(row.countryCode),
          Postal: valueToString(row.postalCode),
          PostalTo: null,
        },
        NumberPieces: valueToNumber(row.numberOfPieces),
        Mileage: valueToNumber(row.legMile),
        Weight: valueToNumber(row.weight),
        LegMiles: valueToNumber(row.legMile),
        ActualCity: valueToString(row.city),
        ActualState: valueToString(row.stateCode),
        TripMiles: 0,
      })),
      Taxes: data.taxes.map(({ codeId, codeDesc }) => ({
        TaxCode: codeId,
        Description: codeDesc,
        BilledAmount: 0,
        CurrencyCode: data.globalRateShopForm?.currencyCode ? data.globalRateShopForm?.currencyCode : '**',
      })),
      CriteriaId: 1,
      Source: 'RateShop',
      AuditType: null,
      CustomerKey: valueToNumber(data.globalRateShopForm?.customerKey),
      CarrierKey: data.globalRateShopForm?.customerKey
        ? data.carriers.map(({ carrierKey }) => carrierKey).join(',')
        : '**',
      BranchKey: valueToNumber(data.globalRateShopForm?.branchKey),
      TrailerKey: data.globalRateShopForm.trailerKey ? valueToNumber(data.globalRateShopForm.trailerKey) : -1,
      ShipmentDate: data.globalRateShopForm.shipmentDate
        ? `/Date(${data.globalRateShopForm.shipmentDate.valueOf()})/`
        : null,
      DeliveryDate: data.globalRateShopForm.deliveryDate
        ? `/Date(${data.globalRateShopForm.deliveryDate.valueOf()})/`
        : null,
      PricingType: valueToString(data.globalRateShopForm.pricingType),
      PricingBasis: valueToString(data.globalRateShopForm.pricingBasis),
      CurrencyCode: data.globalRateShopForm.currencyCode ? valueToString(data.globalRateShopForm.currencyCode) : '**',
      CargoType: data.globalRateShopForm.cargoType ? data.globalRateShopForm.cargoType.join(',') : '**',
      WeightUnitOfMeasure: valueToString(data.globalRateShopForm.measurementUit),
      ServiceKey: -1,
      ServiceCode: '**',
      IntercompanyType: valueToString(data.globalRateShopForm.shipmentTerms),
      DiscountMode: valueToString(data.globalRateShopForm.shipmentType),
      ShipmentTerms: valueToString(data.globalRateShopForm.shipmentTerms),
      TimeFrame: valueToString(data.globalRateShopForm.timeFrame),
      TransportationMode: '**',
      LinerCode: data.globalRateShopForm.LinerCode ? data.globalRateShopForm.LinerCode : null,
      LinerType: data.globalRateShopForm.LinerType ? data.globalRateShopForm.LinerType : null,
      AccountNumber: '',
      IsShipmentRateshop: 'N',
      PackageBranchKeys: '-1',
      MileageMile: 0,
      MileageKilometer: 0,
      Weight: sumBy(data.items, ({ billWeight }) => billWeight),
      Cube: sumBy(data.items, ({ cube }) => cube),
      ProductCode: valueToString(data.globalRateShopForm.productCode),
      Debug: false,
      TaxableValue: 0,
      DeclaredValue: valueToNumber(data.globalRateShopForm.declaredValue),
      CODValue: valueToNumber(data.globalRateShopForm.CODValue),
      LDMValue: valueToNumber(data.globalRateShopForm.LDMValue),
      ItemLevelRating: false,
      ContractNumber: null,
      FreightChargeBilled: 0,
      TotalAccessorialBilled: 0,
    },
  };
};

export const convertRateEnginApiResponseToRateShopModule = (_data) => {
  let data = _data || [];
  if (data) {
    data = data.map((row) => {
      const tariffRateDate = convertDateToMoment(row.TariffRateDate);
      const pricingEffectiveFrom = convertDateToMoment(row.PricingEffectiveFrom);
      const pricingEffectiveTo = convertDateToMoment(row.PricingEffectiveTo);
      const tariffEffectiveFrom = convertDateToMoment(row.TariffEffectiveFrom);
      const tariffEffectiveTo = convertDateToMoment(row.TariffEffectiveTo);
      return {
        accessorials: row?.Accessorials
          ? row?.Accessorials?.map((accRow) => ({
              auditedChargeAmount: accRow?.AuditedChargeAmount,
              description: accRow?.Description,
              currencyCode: accRow?.CurrencyCode,
              accessorialCode: accRow?.AccessorialCode,
              calculationType: accRow?.CalculationType,
              effectiveFromDate: formateWithMoment(accRow.EffectiveFromDate, 'DD-MMM-YYYY'),
              effectiveToDate: formateWithMoment(accRow.EffectiveToDate, 'DD-MMM-YYYY'),
              fuelChargeIndicator: accRow?.FuelChargeIndicator,
              discountAmount: accRow?.DiscountAmount,
              note: accRow?.ErrorMessage,
            }))
          : [],
        cargoType: row.CargoType,
        carrierKey: row.CarrierKey,
        carrierName: row.CarrierName,
        currencyCode: row.CurrencyCode,
        directPoint: row.DirectPoint,
        error_message: row.ErrorMessage,
        mileage: row.MileageMiles,
        mileageKm: row.MileageKilometers,
        pricingBasis: row.PricingBasis,
        pricingType: row.PricingType,
        serviceDesc: row.ServiceDescription,
        serviceKey: row.ServiceKey,
        serviceType: row.ServiceCode,
        shipmentCost: row.ShipmentCost,
        standardDaysTransit: row.StandardDaysTransit,
        trailerDesc: row.TrailerDescription,
        equipmentTypeDetail: row.TrailerDescription,
        trailerkey: row.TrailerKey,
        convertedCost: row.ConvertedCost,
        freightAccessorialCollection: row.Accessorials,
        convertedCurrencyCode: row.ConvertedCurrency,
        spotQuoteNumber: row.SpotQuoteContractNumber,
        bidComment: row.ErrorMessage,
        effectiveTo: convertDateToMoment(row.PricingEffectiveTo),
        createdOn: moment(new Date()),
        TariffKey: row.TariffKey,
        pricingDetailKey: row.PricingKey,
        accessorialCost: sum(
          row.accessorials ? row.accessorials.map(({ AuditedChargeAmount }) => AuditedChargeAmount) : [],
        ),
        rateShopKey: '',
        rateType: '',
        flagStandardTranit: '',
        viewCargoType: null,
        isRateEntry: null,
        totalShipmentCost: row.TotalShipmentCost,
        laneId: row.LaneId,
        branchDescription: row.BranchDescription,
        grossCharge: row.GrossCharge,
        totalDiscount: row.TotalDiscount,
        discountPercentage: row.DiscountPercentage,
        ABSTotalCharge: row.ABSTotalCharge,
        totalAccessorialCharge: row.TotalAccessorialCharge,
        totalTaxCharge: row.TotalTaxCharge,
        bureauMinimumUsed: row.BureauMinimumUsed,
        ABSMinimumUsed: row.ABSMinimumUsed,
        ABSMaximumUsed: row.ABSMaximumUsed,
        tariffName: row.TariffName,
        tariffRateDate: tariffRateDate ? tariffRateDate?.format('(mm/dd/yyyy)') : '',
        pricingEffectiveFrom: pricingEffectiveFrom ? pricingEffectiveFrom?.format('(DD-MMM-YYYY)') : '',
        pricingEffectiveTo: pricingEffectiveTo ? pricingEffectiveTo?.format('(DD-MMM-YYYY)') : '',
        tariffEffectiveFrom: tariffEffectiveFrom ? tariffEffectiveFrom?.format('(DD-MMM-YYYY)') : '',
        tariffEffectiveTo: tariffEffectiveTo ? tariffEffectiveTo?.format('(DD-MMM-YYYY)') : '',
        accountNumber: row.AccountNumber,
        tariffKey: row.TariffKey,
        lineType: row.AirRailEquipmentType || 'N/A',
        liner: row.AirRailOceanLiner || 'N/A',
        laneCode: row.LaneCode || 'N/A',
        laneKey: row.LaneKey || 'N/A',
        items: row.Details
          ? row.Details.map((item) => ({
              ...item,
              numberOfPieces: item.NumberOfPieces,
              billedQuantity: item.BilledQuantity,
              ratingClass: item.RatingClass,
              ABSMinimumUsed: item.ABSMinimumUsed,
              ABSMaximumUsed: item.ABSMaximumUsed,
              rateCostPer: item.RateCostPer,
              discountAmount: item.DiscountAmount,
              billedWeight: item.BilledWeight,
              billedWeightUOM: item.BilledWeightUOM,
              actualWeight: item.ActualWeight,
              pricingBasis: item.PricingBasis,
              rateCharge: item.RateCharge,
              totalCharge: item.TotalCharge,
              actualClass: item.ActualClass,
            }))
          : [],
        taxes: row.Taxes
          ? row.Taxes.map((tax) => ({
              ...tax,
              taxCode: tax.TaxCode,
              description: tax.Description,
              calculationType: tax.CalculationType,
              taxType: tax.TaxType,
              effectiveFromDate: formateWithMoment(tax.EffectiveFromDate, 'DD-MMM-YYYY'),
              effectiveToDate: formateWithMoment(tax.EffectiveToDate, 'DD-MMM-YYYY'),
              auditedChargeAmount: tax.AuditedChargeAmount,
              note: tax.ErrorMessage,
            }))
          : [],
        note: row.ErrorMessage,
        totalDeficitCharge: row.TotalDeficitCharge,
        totalDeficitWeight: row.TotalDeficitWeight,
        deficitWeight: row.DeficitWeight,
        deficitRate: row.DeficitRate,
      };
    });
  }
  data = data.filter(({ totalShipmentCost }) => {
    return Number(totalShipmentCost) > 0;
  });
  data = orderBy(data, ['totalShipmentCost'], ['asc']);
  // TODO: use native Object.groupBy
  return groupBy(data, ({ laneId }) => laneId);
};

export const convertParcelExpressUIToRateAPI = (data, customerKey, isRateRequest) => {
  const carrierData = isRateRequest
    ? {
        rateFedex: Boolean(data?.carrierForm?.rateFedex),
        fedexAccount: valueToString(data?.carrierForm?.fedexAccount),
        rateUPS: Boolean(data?.carrierForm?.rateUPS),
        upsAccount: valueToString(data?.carrierForm?.upsAccount),
        rateDHL: Boolean(data?.carrierForm?.rateDHL),
        dhlAccount: valueToString(data?.carrierForm?.dhlAccount),
        shipperAccountNo: valueToString(data?.shipmentInformationForm?.shipperAccountNo),
        ShipmentTerms: valueToString(data?.shipmentInformationForm?.shipmentTerms),
      }
    : {
        LabelFedex: false,
        fedexAccount: '',
        LabelUPS: false,
        upsAccount: '',
        LabelDHL: false,
        dhlAccount: '',
        ShipmentType: valueToString(data?.shipmentInformationForm?.shipmentType),
        ShipmentTerms: valueToString(data?.shipmentInformationForm?.shipmentTerms),
        ShipperAccountNumber: valueToString(data?.shipmentInformationForm?.accountNo),
        shipperAccountNo: valueToString(data?.shipmentInformationForm?.shipperAccountNo),
        dutyTaxAccountNo: valueToString(data?.shipmentInformationForm?.dutyTaxAccountNo),
        declaredValue: valueToNumber(data?.shipmentInformationForm?.declaredValue),
      };

  if (!isRateRequest) {
    if (data.SelectedRate.carrierType === SP_CARRIERS_TYPES.FEDEX) {
      carrierData.LabelFedex = true;
      carrierData.fedexAccount = valueToString(data?.carrierForm?.fedexAccount);
    } else if (data.SelectedRate.carrierType === SP_CARRIERS_TYPES.UPS) {
      carrierData.LabelUPS = true;
      carrierData.upsAccount = valueToString(data?.carrierForm?.upsAccount);
    } else if (data.SelectedRate.carrierType === SP_CARRIERS_TYPES.DHL) {
      carrierData.LabelDHL = true;
      carrierData.dhlAccount = valueToString(data?.carrierForm?.dhlAccount);
    }
  }

  let shipDate;
  // If shipment time and shipTimeZone is provided then we need to merge the shipTime with shipDate and need to convert the selected timezone to UTC
  if (data.locationForm.shipDate && data.locationForm.shipTime && data.locationForm.shipTimeZone) {
    shipDate = mergeDateAndTimeObjectsWithTimeZone(
      moment(data.locationForm.shipDate),
      moment(data.locationForm.shipTime),
      data.locationForm.shipTimeZone,
    );
  } else {
    shipDate = data.locationForm.shipDate;
  }

  let latestPickupTime;
  // If shipment time and shipTimeZone is provided then we need to merge the shipTime with shipDate and need to convert the selected timezone to UTC
  if (data.locationForm.shipDate && data.locationForm.latestPickupTime && data.locationForm.shipTimeZone) {
    latestPickupTime = mergeDateAndTimeObjectsWithTimeZone(
      moment(data.locationForm.shipDate),
      moment(data.locationForm.latestPickupTime),
      data.locationForm.shipTimeZone,
    );
  }

  return {
    parcelPackage: data.packages.map((packageDetails) => ({
      weight: valueToString(packageDetails.weight),
      weightUOM: valueToString(packageDetails.weightUOM),
      packagesQuantity: valueToNumber(packageDetails.noPackages),
      length: valueToString(packageDetails.length),
      width: valueToString(packageDetails.width),
      height: valueToString(packageDetails.height),
      dimensionsUOM: valueToString(packageDetails.dimensionsUOM),
      shipmentDetailsID: valueToNumber(packageDetails.shipmentDetailsID),
    })),
    origin: {
      contactName: valueToString(data.locationForm?.ORIGIN_contactName),
      phoneCode: valueToString(data.locationForm?.ORIGIN_phoneCode),
      phoneNumber: valueToString(data.locationForm?.ORIGIN_phoneNumber),
      phoneExtension: valueToString(data.locationForm?.ORIGIN_phoneExtension),
      contactEmail: valueToString(data.locationForm?.ORIGIN_contactEmail),
      companyName: valueToString(data.locationForm?.ORIGIN_companyName),
      streetAddress: valueToString(data.locationForm?.ORIGIN_streetAddress),
      streetAddress2: valueToString(data.locationForm?.ORIGIN_streetAddress2),
      countryCode: valueToString(data.locationForm?.ORIGIN_countryCode),
      postalCode: valueToString(data.locationForm?.ORIGIN_postalCode),
      state: valueToString(data.locationForm?.ORIGIN_state),
      city: valueToString(data.locationForm?.ORIGIN_city),
      deliveryDate: convertDateStringtoMoment(shipDate),
    },
    destination: {
      contactName: valueToString(data.locationForm?.DEST_contactName),
      phoneCode: valueToString(data.locationForm?.DEST_phoneCode),
      phoneNumber: valueToString(data.locationForm?.DEST_phoneNumber),
      phoneExtension: valueToString(data.locationForm?.DEST_phoneExtension),
      contactEmail: valueToString(data.locationForm?.DEST_contactEmail),
      companyName: valueToString(data.locationForm?.DEST_companyName),
      streetAddress: valueToString(data.locationForm?.DEST_streetAddress),
      streetAddress2: valueToString(data.locationForm?.DEST_streetAddress2),
      countryCode: valueToString(data.locationForm?.DEST_countryCode),
      postalCode: valueToString(data.locationForm?.DEST_postalCode),
      state: valueToString(data.locationForm?.DEST_state),
      city: valueToString(data.locationForm?.DEST_city),
      deliveryDate: convertDateStringtoMoment(shipDate),
    },
    branch: valueToNumber(data?.shipmentInformationForm?.branchKey),
    customerKey: valueToNumber(customerKey),
    shipmentNumber: valueToString(data.shipmentInformationForm?.shipmentNo),
    shipmentKey: valueToNumber(data.shipmentInformationForm?.shipmentKey),
    ...carrierData,
    ...(latestPickupTime && !isRateRequest
      ? {
          latestPickupTime: convertDateStringtoMoment(latestPickupTime),
        }
      : {}),
  };
};

export const freightClassCalculator = (_productList, isHideTheRowDetails = false) =>
  new Promise((resolve, reject) =>
    (async () => {
      try {
        let productList = _productList || [];
        await validateProductForCalculateClass(productList, isHideTheRowDetails);
        productList = productList.map((row) => ({
          ...row,
          class: calCulateFreightClass(
            row.length,
            row.width,
            row.height,
            row.weight,
            row.weightUom,
            row.billQty,
            row.billQtyUom,
            row.dimUom,
            row.cube,
          ),
        }));
        resolve(productList);
      } catch (error) {
        reject(error);
      }
    })(),
  );

export const convertRateEntryToAPI = (data) => ({
  cargoType: valueToString(data?.cargoType),
  carrierKey: valueToNumber(data?.carrierKey),
  carrierName: valueToString(data?.carrierName),
  currencyCode: valueToString(data?.currencyCode),
  shipmentCost: valueToNumber(data?.shipmentCost),
  standardDaysTransit: valueToNumber(data?.standardDaysTransit),
  trailerKey: valueToNumber(data?.trailerKey),
  trailerDesc: valueToString(data?.trailerDesc),
  createdBy: valueToNumber(data?.createdBy),
  shipmentKey: valueToNumber(data?.shipmentKey),
  createdOn: truncateTimeZoneDate(convertDateUserLocalToUTCToEST(data?.createdOn)),
});

export const getShipmentOriginDestinationDetails = (_stops) => {
  const stops = orderBy(_stops, ['displaySequence'], ['asc']);

  return { origin: stops[0], destination: stops[stops.length - 1] };
};

export const alignStopsByStopNo = (_transportationList, index, _name) => {
  let transportationList = _transportationList || [];
  const seqParam = _name || 'displaySequence';
  const existIndexNo = transportationList?.findIndex(
    (row, indexLocal) => Number(row?.[seqParam]) === transportationList?.[index]?.[seqParam] && indexLocal !== index,
  );

  if (existIndexNo >= 0) {
    transportationList = arrayMove(transportationList, index, existIndexNo);
    transportationList = transportationList.map((row, index) => ({
      ...row,
      [seqParam]: index + 1,
    }));
    transportationList = orderBy(transportationList, [seqParam], ['asc']);
  }
  return transportationList;
};

export const generateStopsSequence = (_stops, index) => {
  let stops = _stops || [];
  stops = stops.map((row) => ({
    ...row,
    sequence: valueToNumber(row.sequence),
  }));
  stops[index].gridOperation = Number(stops[index].gridOperation);
  if (stops[index].gridOperation === 1) {
    // new stop
    stops[index].sequence = Math.max(...stops.map(({ sequence }) => (sequence ? sequence : 0))) + 1;
  } else if (stops[index].gridOperation === 2) {
    // modifying stop
    const stopsByType = stops.filter((stop) => stop.stopType === stops[index].stopType);
    const stopsBySequence = stopsByType.filter((stop) => stop.sequence === stops[index].sequence);

    if (stopsBySequence.length > 1) {
      stops[index].sequence = Math.max(...stopsByType.map(({ sequence }) => (sequence ? sequence : 0))) + 1;
    }
  } else if (stops[index].gridOperation === 3) {
    // deleting stop
  }
  return stops;
};

export const getShippingLabelPrintData = (shipmentDetails, _customerKey) => {
  let customerKey = _customerKey || 0;
  customerKey = Number(customerKey);
  const shipperInfo = shipmentDetails?.transportationList?.[0] ? shipmentDetails?.transportationList?.[0] : {};
  const consigneeInfo =
    shipmentDetails?.transportationList?.length > 0
      ? shipmentDetails?.transportationList?.[shipmentDetails?.transportationList?.length - 1]
      : {};
  const data = {
    shipperName: customerKey === 6027 ? 'CELEROS FLOW TECHNOLOGY (FLOW AMERICA LLC)' : shipperInfo?.name,
    shipperAddress1: customerKey === 6027 ? '8800 WESTPAIN DR' : shipperInfo?.address1,
    shipperAddress2:
      customerKey === 6027
        ? 'HOUSTON, TX 77041'
        : `${shipperInfo?.city}, ${shipperInfo?.stateCode} ${shipperInfo?.zipCode}`,
    shipperPhone: shipperInfo?.businessPhone,
    consigneeName: customerKey === 6027 ? 'CELEROS FLOW TECHNOLOGY (FLOW AMERICA LLC)' : consigneeInfo?.name,
    consigneeAddress1: customerKey === 6027 ? '8800 WESTPAIN DR' : consigneeInfo?.address1,
    consigneeAddress2:
      customerKey === 6027
        ? 'HOUSTON, TX 77041'
        : `${consigneeInfo?.city}, ${consigneeInfo?.stateCode} ${consigneeInfo?.zipCode}`,
    consigneePhone: consigneeInfo?.businessPhone,
    carrierName: shipmentDetails?.carrierName,
    bolNumber: shipmentDetails?.bolNumber,
    proNo: shipmentDetails?.proNo,
    purchaseOrderNumber: shipmentDetails?.purchaseOrderNumber,
    salesOrderNumber: shipmentDetails?.salesOrderNumber,
    serviceLevel: shipmentDetails?.serviceLevel,
  };
  return data;
};

export const constructDataForRateEngine = async (props) => {
  const { shipmentDetailsLocal, filterData, shipmentBranches, accountingFormData, havingAccessForMenu, isAPIRateShop } =
    props;
  let accessorials = [];
  if (accountingFormData?.accessorials) {
    accessorials = accountingFormData?.accessorials
      .filter((accessorial) => (havingAccessForMenu ? accessorial.isChecked === true : true))
      ?.map((row) => ({
        AccessorialCode: row.accChargeType?.trim(),
        Description: row.codeDesc,
        BilledAmount: 0,
        CurrencyCode: null,
      }));
  }

  const branchDetails = shipmentBranches?.find(({ branchKey }) => branchKey === shipmentDetailsLocal.branchKey);
  filterData.cargoType = filterData.cargoType?.length ? filterData.cargoType.join(',') : '';
  const formData = shipmentRateShopLocalToRateEngineAPI(
    accessorials,
    shipmentDetailsLocal,
    filterData,
    branchDetails?.currencyCode ? branchDetails?.currencyCode : '**',
    isAPIRateShop,
  );
  formData.isNeedToSave = true;
  formData.isAPIRateShop = isAPIRateShop;
  return formData;
};

//NOTE - To remove the products if a product having zero values for certain fields.
//NOTE - For now this function used in parcel express after getting products from API.
export const filterZeroValuesProducts = (products) =>
  products.filter(
    ({ weight, billQty, height, length, width }) => weight > 0 && billQty > 0 && height > 0 && length > 0 && width > 0,
  );

export const generatePayloadForCheckAddress = (data) => ({
  origin: {
    customerKey: data.customerKey,
    branchKey: data.branch,
    name: data.origin.companyName,
    addr1: data.origin.streetAddress,
    addr2: data.origin.streetAddress2,
    city: data.origin.city,
    state: data.origin.state,
    zip: data.origin.postalCode,
    countryCode: data.origin.countryCode,
    contactName: data.origin.contactName,
    contactEmail: data.origin.contactEmail,
    phone: data.origin.phoneNumber,
    phoneExt: data.origin.phoneExtension,
  },
  destination: {
    customerKey: data.customerKey,
    branchKey: data.branch,
    name: data.destination.companyName,
    addr1: data.destination.streetAddress,
    addr2: data.destination.streetAddress2,
    city: data.destination.city,
    state: data.destination.state,
    zip: data.destination.postalCode,
    countryCode: data.destination.countryCode,
    contactName: data.destination.contactName,
    contactEmail: data.destination.contactEmail,
    phone: data.destination.phoneNumber,
    phoneExt: data.destination.phoneExtension,
  },
});
